import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { isZitadelMode, urlParams } from '@/app/urlParams';
import { setUrlToken } from '@/services/httpClient';

import App from './App';
import './styles/globals.css';

// Inject the Zitadel token synchronously — before any React render — so that
// the very first API calls (game-config, etc.) already carry the Authorization
// header. Must happen before createRoot() so there is no window where the
// interceptor fires without a token.
if (isZitadelMode) {
  setUrlToken(urlParams.token);
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found. Check index.html has <div id="root">.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
